<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">CONTABILI</h1>
    </div>

    <!--********** CAMPO DI RICERCA **********-->
    <div class="columns is-mobile is-centered" v-if="props.campoRicercaVisibile==true">
        <div class="column is-5">
            <div class="control">
                <input class="input is-primary" type="text" v-model="tempTestoRicerca" placeholder="Cerca..." @keyup.enter="bCerca">
            </div>
        </div>
    </div>

    <!--********** TABELLA CONTABILI **********-->
    <div class="columns is-mobile is-centered has-background-light p-2" v-if="props.lavoro!=null">
        <!-- <p>Rimane da fatturare: {{ generaStringa(dbClienti[props.cliente].lavori[props.lavoro].info.totSbilancio, '0,00', true) }}</p> -->
        <p>Rimane da fatturare: {{ generaStringa(leggiInfoDB(dbClienti[props.cliente].lavori[props.lavoro]).totSbilancio, '0,00', true) }}</p>
        <p v-if="!props.visioneCompatta && tipoSchermo()=='largo'">
            &nbsp; &nbsp; &nbsp; &nbsp;
            <a @click="scaricaXlsxContabilita(elencoContabili)" title="Scarica in formato Excel"><i class="fas fa-download"></i></a>
        </p>
    </div>
    <div class="table-scroll-x">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaContabile(-1)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th v-if="props.lavoro==null">Lavoro</th>
                    <th class="has-text-centered">Data</th>
                    <th>Causale</th>
                    <th class="has-text-centered">Preventivo</th>
                    <th class="has-text-centered">Consuntivo</th>
                    <th class="has-text-centered">Fattura</th>
                    <!-- <th class="has-text-centered">Sbilancio</th> -->
                    <th v-if="props.lavoro!=null">Ordine</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(cc, index) in elencoContabili" :key="leggiInfoDB(cc).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaContabile(leggiInfoDB(cc).id, leggiInfoDB(cc).idLavoro, leggiInfoDB(cc).idCliente)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(cc).id}}</td>
                    <td v-if="props.lavoro==null">{{leggiInfoDB(cc).stringaLavoro}}</td>
                    <td class="has-text-centered">{{dataDaTimestamp(cc.data, 'testo')}}</td>
                    <td>{{cc.causale}}</td>
                    <td class="has-text-right">{{generaStringa(cc.preventivo, '0,00')}}</td>
                    <td class="has-text-right">{{generaStringa(cc.consuntivo, '0,00')}}</td>
                    <td class="has-text-right">{{generaStringa(cc.fattura, '0,00')}}</td>
                    <!-- <td class="has-text-right">{{generaStringa(sommaContabili(cc.consuntivo,cc.fattura), '0,00', true)}}</td> -->
                    <td class="has-text-right" v-if="props.lavoro!=null">{{cc.ordine}}</td>
                </tr>
                <tr v-if="props.lavoro!=null">
                    <td></td>
                    <td v-if="mostraInfoSviluppo"></td>
                    <td v-if="mostraInfoSviluppo"></td>
                    <td v-if="props.lavoro==null"></td>
                    <td>Totale</td>
                    <td></td>
                    <!-- <td class="has-text-right">{{generaStringa(dbClienti[props.cliente].lavori[props.lavoro].info.totPreventivi, '0,00')}}</td>
                    <td class="has-text-right">{{generaStringa(dbClienti[props.cliente].lavori[props.lavoro].info.totConsuntivi, '0,00')}}</td>
                    <td class="has-text-right">{{generaStringa(dbClienti[props.cliente].lavori[props.lavoro].info.totFatture, '0,00')}}</td> -->
                    <td class="has-text-right">{{generaStringa(leggiInfoDB(dbClienti[props.cliente].lavori[props.lavoro]).totPreventivi, '0,00')}}</td>
                    <td class="has-text-right">{{generaStringa(leggiInfoDB(dbClienti[props.cliente].lavori[props.lavoro]).totConsuntivi, '0,00')}}</td>
                    <td class="has-text-right">{{generaStringa(leggiInfoDB(dbClienti[props.cliente].lavori[props.lavoro]).totFatture, '0,00')}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { dbClienti, leggiInfoDB } from "@/code/gestioneDB";
    import { dataDaTimestamp, mostraInfoSviluppo, generaStringa, scaricaXlsxContabilita, tipoSchermo } from "@/code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        lavoro: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        titoloVisibile: {
            type: Boolean,
            default: true }
    });
    // const emit = defineEmits(['contabileSelezionata']);
    const emit = defineEmits(['elementoSelezionato', 'statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE
    let testoRicerca = ref(props.testoDaCercare);
    let tempTestoRicerca = ref(testoRicerca.value);
    const elencoContabili = computed(()=>{
        let tempElencoContabili = [];
        if (props.lavoro==null) {
            if (props.cliente==null) {
                for(const cl in dbClienti.value){
                    for(const lv in  dbClienti.value[cl].lavori){
                        for(const cc in  dbClienti.value[cl].lavori[lv].contabili){
                            tempElencoContabili.push(dbClienti.value[cl].lavori[lv].contabili[cc]);
                        }
                    }
                }
            } else {
                for(const lv in dbClienti.value[props.cliente].lavori){
                    for(const cc in dbClienti.value[props.cliente].lavori[lv].contabili){
                        tempElencoContabili.push(dbClienti.value[props.cliente].lavori[lv].contabili[cc]);
                    }
                }
            }
        } else {
            const cl = props.cliente;
            const lv = props.lavoro;
            for(const cc in  dbClienti.value[cl].lavori[lv].contabili){
                tempElencoContabili.push(dbClienti.value[cl].lavori[lv].contabili[cc]);
            }
        }
        ordinaElencoContabili(tempElencoContabili);
        filtraElencoElementi(tempElencoContabili, testoRicerca.value, ['ordine']);
        return tempElencoContabili;
    });

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE
    function bCerca() {
        testoRicerca.value = tempTestoRicerca.value;
    }

    function bSelezionaContabile(idCt, idLv, idCl) {
        let tempIdCl;
        let tempIdLv;
        tempIdCl = props.cliente==null ? idCl : props.cliente;
        tempIdLv = props.lavoro==null ? idLv : props.lavoro;
        emit('elementoSelezionato', {
            tipo: 'contabile',
            idCliente: tempIdCl,
            idLavoro: tempIdLv,
            idDico: idCt
        });
    }

    function ordinaElencoContabili(elenco) {
        // Ordina elenco
        elenco.sort( (a, b) => {
            return (a.ordine-b.ordine);
        });
        return elenco;
    }    

    function filtraElencoElementi(elencoEl, testo, campi) {
        // Filtra viewLeads cercando il testo nei campi indicati dall'array di stringhe 'campi'
        if ( testo ) {
            for (let i=0; i < elencoEl.length; i++) {
                const regexCerca = new RegExp(testo, 'i');
                let temp = null;
                let pos = -1;
                for (const cc in campi) {
                    if (pos == -1) {
                        if ( Array.isArray(campi[cc]) ) {
                            temp = elencoEl[i][campi[cc][0]][campi[cc][1]];
                        } else {
                            temp = elencoEl[i][campi[cc]];
                        }
                        pos = String(temp).search(regexCerca);
                    }
                }
                if (pos == -1) {
                    elencoEl.splice(i,1);
                    i--;
                }
            }
        }
    }

    // function sommaContabili(somma, sottrae) {
    //     somma = (somma)? somma: 0;
    //     sottrae = (sottrae)? sottrae: 0;
    //     totaleContabili = totaleContabili + somma - sottrae;
    //     return totaleContabili;
    // }

</script>

<style>
    .table th.prima-riga {
        border: none;
    }
    .table th.bordi-laterali {
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
        /* border-width: 0 0 1px; */
    }
</style>